export default {
	properties: [
		// RADIO
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			show: true,
		},
		{
			text: 'Pocision',
			key: 'position',
			type: 'number',
			value: '',
			show: true,
		},
	],
	singular_model_name_spanish: 'Estado de Produccion',
	plural_model_name_spanish: 'Estados de Produccion',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}